export function getPercentage(value: number, total: number): string {
    if (total === 0) {
        return '0';
    }
    return ((value * 100) / total).toFixed(2);
}